import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		edit: {
			panel: {
				width: '900px'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		}
	}
}
